import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, map, of, Subject } from 'rxjs';
import { UsersApiService } from 'src/app/services/users-api.service';
import { ApprovalRequest } from 'src/app/models/approvalRequest.model';
import { RemindersApiService } from 'src/app/services/reminders-api.service';
import { ApprovalDetails } from 'src/app/models/approvalDetails.model';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'que-approval',
    imports: [CommonModule],
    templateUrl: './approval.component.html',
    styleUrls: ['./approval.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApprovalComponent {
    #route = inject(Router)
    #activeRoutes = inject(ActivatedRoute)
    #reminderApiService = inject(RemindersApiService)
 
    guid: any;
    request?: ApprovalRequest;
    #detailsSubject:Subject<ApprovalDetails>=new Subject();
    #approvedSubject:Subject<boolean>=new Subject();
    details$ = toSignal(this.#detailsSubject.asObservable());
    isapproved$ = toSignal(this.#approvedSubject.asObservable());

    constructor() {

    }
    ngOnInit() {
        const params = this.#activeRoutes.snapshot.queryParams;
        this.request = {
            // guid: params['guid'],
            email: params['email'],
            recipientId: params['recipientId'],
        };
        this.guid = params['guid'];
        if (!this.guid || !this.request.email || !this.request.recipientId)
            this.#route.navigate(['notFound'])
        this.#reminderApiService.getMailToApprovalByGuid(this.request, this.guid).subscribe(
            x => {
                if (!x) { this.#route.navigate(['notFound']) }
                else {
                    this.#detailsSubject.next(x);
                }
            }
        )
        // NOTE: can return false is some parameters are missing
        return true;
    }
    approval() {
        if (this.request && this.guid) {
            this.#reminderApiService.approval(this.request, this.guid).subscribe(
                x => {
                    if (!x) { this.#route.navigate(['notFound']) }
                    else {
                        this.#approvedSubject.next(x);
                    }
                }
            );
        }
        else {
           // console.log("error with guid");
        }
    }
}
